<template>
  <div>
    <ValidationObserver ref="form">
      <form @submit.prevent="handleSubmit">
        <div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <h3 class="mb-4"><strong>{{ $t('InfoGeneral') }}</strong></h3>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div style="height:70px">
                <vx-input-group class="mb-2 mt-3">
                  <ValidationProvider name="Nombre" rules="required" v-slot="{ errors }">
                    <vs-input label-placeholder="Nombre" v-model="name" class="w-full" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </ValidationProvider>
                </vx-input-group>
              </div>

              <vx-input-group class="mt-5">
                <select v-model="selected" class="w-full" name="optSelected" label-placeholder="Tipo">
                  <option v-for="option in options" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>
              </vx-input-group>


                <div v-if="selected == '1'" style="height:70px;">
                  <vx-input-group class="mb-2 mt-4">
                    <ValidationProvider name="Porcentaje" rules="required|min_value:1|max_value:100" v-slot="{ errors }">
                      <vs-input label-placeholder="Porcentaje" type="number" v-model="percent" class="w-full" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>
                </div>

                <div v-else-if="selected == '2'">

                  <div class="vx-row ml-2">
                  <div class="mr-2" style="height:70px">
                    <vx-input-group class="mb-2 mt-4">
                      <ValidationProvider name="Consumidos" rules="required|min_value:1|max_value:5" v-slot="{ errors }">
                        <vs-input label-placeholder="Consumidos" type="number" v-model="discOpt1" />
                        <p class="text-danger">{{ errors[0] }}</p>
                      </ValidationProvider>
                    </vx-input-group>
                  </div>
                  <div class="ml-2" style="height:70px">
                    <vx-input-group class="mb-2 mt-4">
                      <ValidationProvider name="A pagar" rules="required|min_value:1|max_value:5" v-slot="{ errors }">
                        <vs-input label-placeholder="A pagar" type="number" v-model="discOpt2" class="w-full" />
                        <p class="text-danger">{{ errors[0] }}</p>
                      </ValidationProvider>
                    </vx-input-group>
                  </div>
                  </div>
                  <div class="mt-6" style="height:70px;">
                    <ValidationProvider name="Producto" rules="required" v-slot="{ errors }">
                      <vs-select autocomplete label="Producto" v-model="product" class="selectDish w-full">
                        <vs-select-item
                          :key="index"
                          :value="item.id"
                          :text="item.name"
                          v-for="(item, index) in itemsDishes"
                        />
                      </vs-select>
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </div>
                </div>

              <div v-else-if="selected == '3'" style="height:70px">
                  <vx-input-group class="mb-2 mt-4">
                    <ValidationProvider name="Descuento" rules="required|min_value:1|max_value:100" v-slot="{ errors }">
                      <vs-input label-placeholder="Descuento" type="number" v-model="discount" class="w-full" />
                      <p class="text-danger">{{ errors[0] }}</p>
                    </ValidationProvider>
                  </vx-input-group>

              </div>
            </div>

            <div class="vx-col md:w-1/2 w-full">
              <div class="vx-row ml-2" style="align-items: baseline; height:100px;">
                <div class="mr-5" style="width: min-content">
                  <CalendarInput :label="$t('Hasta')" v-model="finished_at"></CalendarInput>
                 </div>
                 <div class="ml-5">
                <vx-input-group class="mb-2 mt-2">
                  <ValidationProvider name="Hora" rules="required" v-slot="{ errors }">
                    <TimeInput
                      v-model="finished_at_time"
                      :label="$t('Hora')"
                      class="w-full"
                    ></TimeInput>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </ValidationProvider>
                </vx-input-group>
                 </div>
              </div>
              <div style="height:75px;">
                <vx-input-group class="mb-2 mt-10 ml-2 w-3/4">
                  <ValidationProvider name="Cantidad" rules="min_value:1|required_if:globalCheck,false" v-slot="{ errors }">
                    <vs-input :disabled="globalCheck" label-placeholder="Cantidad" type="number" v-model="amount"  />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </ValidationProvider>
                </vx-input-group>
              </div>
              <ValidationProvider name="globalCheck" v-slot="{ errors }">
                <div class="mt-3"><vs-checkbox v-model="globalCheck">{{ $t('Global') }}</vs-checkbox></div>
              </ValidationProvider>
             </div>

            <div class="vx-col w-full">
              <vx-input-group class="mb-2 mt-5">
                <ValidationProvider name="Descripción" rules="required" v-slot="{ errors }">
                  <p>{{ $t('Descripcion') }}</p>
                  <vs-textarea v-model="description" rows="2" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </ValidationProvider>
              </vx-input-group>
            </div>
          </div>
          <div class="vx-col w-full text-right">
            <vs-button depressed color="success" type="border" class="mr-2" @click.prevent="handleSubmit">
              {{ $t('sale.CreateSale') }}
            </vs-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import ImageDropzone from '../ImageDropzone';
import { mapActions, mapGetters } from 'vuex';
import CalendarInput from '../calendar-input/CalendarInput.vue';
import TimeInput from '../time-input/TimeInput.vue';

export default {
  components: {
    ImageDropzone,
    draggable,
    CalendarInput,
    TimeInput
  },
  data() {
    return {
      selected: 1,
      selectedType: 1,
      optionSelected: '',
      globalCheck: false,
      options: [
        { value: '1', text: 'Porcentaje Descuento' },
        { value: '2', text: 'Promoción NxN' },
        { value: '3', text: 'Descuento €'}
      ],
      name: '',
      type: '',
      description: '',
      discOpt1:1,
      discOpt2:1,
      percent: 1,
      discount:1,
      product: '',
      amount: 1,
      hasParameter: false,
      finished_at: '',
      finished_at_time: '',
      dishes: [],
      isMounted: false,
      itemsPerPage: 15,
    };
  },
  created() {
    this.refreshDishes({ language: this.language });
    if (this.$route.params.idProduct) {
      this.product = this.$route.params.idProduct;
      this.hasParameter = true;
      this.selected = 2;
    }
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    ...mapGetters({
      itemsSales: 'getSales',
      itemsDishes: 'getDishes',
      sale: 'getSale',
      currentRestaurant: 'getCurrentRestaurant',
      language: 'getCurrentLanguage',
    }),
  },
  methods: {
    ...mapActions({
      createSale: 'createSale',
      refreshSales: 'refreshSales',
      refreshDishes:'refreshDishes',
    }),
    handleSubmit() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          setTimeout(() => {
            let textAux = '';
            const errors = this.$refs.form.errors;
            Object.keys(errors).forEach((key) => {
              const error = errors[key];
              if (error.length) {
                error.forEach(function (text) {
                  textAux += `<p>${text}</p>`;
                });
              }
            });
            this.$store.commit('notifications', {
              title: 'Existen errores en el formulario.',
              color: 'danger',
              text: textAux,
            });
            this.$store.commit('showNotifications', true);
          }, 100);
          return;
        }

        this.submitted = true;

        const formData = this.createFormData();

        this.createSale({ sale: formData, language: this.language });

        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.form.reset();
        });
      });
    },

    createFormData() {
      const data = new FormData();
      data.append('name', this.name);
      data.append('type_sale', this.selected);
      if (this.selected === 1 || this.selected === '1') {
        const spec_data = {
          porcentaje: this.percent,
        };
        data.append('type_sale_specification', JSON.stringify(spec_data));
      } else if (this.selected === '2' || this.selected === '2') {
        const spec_data = {
          //NxN: this.discOpt[this.selectedType].text,
          NxN:`${this.discOpt1.toString()}x${this.discOpt2.toString()}`,
          product_id: this.product,
        };
        data.append('type_sale_specification', JSON.stringify(spec_data));
      } else if (this.selected === 3 || this.selected === '3') {
        const spec_data = {
          descuento: this.discount,
        };
          data.append('type_sale_specification', JSON.stringify(spec_data));
      }

      data.append('details', this.description);
      data.append('amount', this.globalCheck ? 0 : this.amount);
      data.append('restaurant_id', this.currentRestaurant);
      data.append('finished_at', `${this.finished_at  } ${  this.finished_at_time}`);

      return data;
    },
  },
};
</script>
<style></style>
